/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PrepLadderIconicSection from './PrepLadderIconicSection';
import GeneralIconicSection from './GeneralIconicSection';

const IconicSection = (props) => {
  const { goalUID } = props;
  const externalApps = useSelector(
    ({ topologies }) => topologies?.data?.[goalUID]?.externalApps
  );

  return externalApps.length ? (
    <PrepLadderIconicSection {...props} />
  ) : (
    <GeneralIconicSection {...props} />
  );
};

IconicSection.propTypes = {
  goalUID: PropTypes.string.isRequired
};

export default IconicSection;
